import React from "react";
import "./App.css";
import LinkPreview from "./components/LinkPreview";

function App() {
  return (
    <div className="App">
      <h2 className="link-preview">React Link Preview</h2>
      <LinkPreview />
    </div>
  );
}

export default App;
